module.exports={
  "css/bookingenius-widget.css": "css/bookingenius-widget-91464fdfd4.css",
  "jquery.webui-popover.js": "jquery-1d7f87ff27.webui-popover.js",
  "vendor1.js": "vendor1-cf7221d65f.js",
  "vendor2.js": "vendor2-81a957840c.js",
  "vendor3.js": "vendor3-b25be2079a.js"
}